module.exports = __webpack_public_path__ + "img/Weak Spring.fe502504.png";